
import Form from "./Form.vue";
import ObjetoData from "./ObjetoData";
import { mapGetters } from "vuex";

export default {
  name: "app-objeto-create",
  data() {
    return {
      objeto: new ObjetoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
